<div class="card">
    <div class="card-header">
        <h3 class="mb-0">Conciliación de Archivos XML</h3>
    </div>

    <div class="card-body">
        <div class="row g-3 mb-3">
        <div class="col-md-6">
            <label for="startDate" class="form-label">Fecha Inicial</label>
            <input type="date" id="startDate" [(ngModel)]="startDate" class="form-control" />
        </div>
        <div class="col-md-6">
            <label for="endDate" class="form-label">Fecha Final</label>
            <input type="date" id="endDate" [(ngModel)]="endDate" class="form-control" />
        </div>
        </div>
        <!-- <div class="mb-3">
        <label for="company" class="form-label">Empresa</label>
        <app-input-autocomplete
            (changeStatus)="selectCompany($event.filterElement)"
            (inputMethod)="searchCompany()"
            [allBorderRadius]="true"
            [filterElements]="companies"
            [placeholder]="'Busca una empresa'"
            [custom]="true"
            [inputs]="inputCompany"
        >
            <ng-template #itemsTemplate let-filter>
            <div items>
                <h5 class="text-info mb-0">
                {{ filter.companyName || filter.name }}
                </h5>
                <span class="text-muted">ID: {{ filter.alphanumericId }} — NIT: <b>{{ filter.companyNIT || filter.nit }}</b></span>
            </div>
            </ng-template>
        </app-input-autocomplete>
        </div> -->
        <div class="text-end">
        <button class="btn btn-success" [disabled]="!startDate || !endDate || !loading" (click)="getReconciliationReport('excel')">
	    	<ng-container *ngIf="loading">
	    		<i class="fa fa-floppy-disk"></i>
	    	</ng-container>
	    	<ng-container *ngIf="!loading">
	    		<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
	    		<span role="status"></span>
	    	</ng-container>
            <span class="ml-2">{{(loading)?'Descargar Excel':'Generando...'}}</span>
	    </button>
        </div>
    </div>
</div>
